import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom"

/* ══════════════════════════════════════════════════════════════
   PUBLIC SITE IMPORTS — Sadece ana siteye ait (Müşterilerin Gördüğü)
   ══════════════════════════════════════════════════════════════ */
import Home from "@/pages/Home"
import Brands from "@/pages/Brands"
import Products from "@/pages/Products"
import Duratiles from "@/pages/Duratiles"
import Kalekim from "@/pages/Kalekim"
import Qua from "@/pages/Qua"
import Vitrafix from "@/pages/Vitrafix"
import References from "@/pages/References"
import Contact from "@/pages/Contact"
import Privacy from "@/pages/Privacy"
import Terms from "@/pages/Terms"
import { QuoteProvider } from "@/context/QuoteContext"
import Navbar from "@/components/Navbar"
import PublicFooter from "@/components/PublicFooter"
import CookieConsent from "@/components/CookieConsent"
import { WhatsAppButton } from "@/components/WhatsAppButton"

import { QuoteDrawer } from "@/components/catalog/QuoteDrawer"

import AboutUs from "@/pages/AboutUs"

/* ══════════════════════════════════════════════════════════════
   PUBLIC LAYOUT — Navbar + Footer ile sarılı, ana site
   ══════════════════════════════════════════════════════════════ */
function PublicLayout() {
  return (
    <QuoteProvider>
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-1">
          <Outlet />
        </main>
        <PublicFooter />
        <QuoteDrawer />
        <CookieConsent />
        <WhatsAppButton />
      </div>
    </QuoteProvider>
  )
}

/* ══════════════════════════════════════════════════════════════
   APP ROUTER
   ══════════════════════════════════════════════════════════════ */
function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* ── PUBLIC SITE ── */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/hakkimizda" element={<AboutUs />} />
          <Route path="/markalar" element={<Brands />} />
          <Route path="/urunler" element={<Products />} />
          <Route path="/duratiles" element={<Duratiles />} />
          <Route path="/kalekim" element={<Kalekim />} />
          <Route path="/qua" element={<Qua />} />
          <Route path="/vitrafix" element={<Vitrafix />} />
          <Route path="/referanslar" element={<References />} />
          <Route path="/iletisim" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
        </Route>
        
        {/* DİKKAT: /app rotaları app.html üzerinden çalışır, buradaki fallback yakalamaz.
            Vite sunucusu /app adresini otomatik olarak app.html adresine devreder. */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
